module.exports = __webpack_public_path__ + "img/ape_mint_live_2.5e20d661.webp";